import type { ReactNode } from 'react';

interface FieldShellProps {
  label: string;
  htmlFor?: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
  hint?: ReactNode;
}

/**
 * 폼 필드 공통 셸 (label + error + hint).
 * input/textarea/select/커스텀 컨트롤을 children 으로 받는다.
 * auth 의 FormField 가 input 전용이라, 게시판 폼(textarea/select 혼합)용으로 분리.
 */
export function FieldShell({
  label,
  htmlFor,
  error,
  required,
  children,
  hint,
}: FieldShellProps) {
  const errorId = error && htmlFor ? `${htmlFor}-error` : undefined;
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="mb-1.5 block text-sm font-semibold text-neutral-800 dark:text-neutral-200"
      >
        {label}
        {required && <span className="ml-0.5 text-red-500">*</span>}
      </label>
      {children}
      {hint && !error && (
        <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400">{hint}</p>
      )}
      {error && (
        <p id={errorId} role="alert" className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}
